import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const TableTabIcon = ({
  width = "26",
  height = "26",
  color = "#B3B3B3",
  rotate,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} rotate={rotate}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 27 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.0625 4.0625C24.0625 3.63152 23.8913 3.2182 23.5865 2.91345C23.2818 2.6087 22.8685 2.4375 22.4375 2.4375H4.5625C4.13152 2.4375 3.7182 2.6087 3.41345 2.91345C3.1087 3.2182 2.9375 3.63152 2.9375 4.0625V21.9375C2.9375 22.3685 3.1087 22.7818 3.41345 23.0865C3.7182 23.3913 4.13152 23.5625 4.5625 23.5625H22.4375C22.8685 23.5625 23.2818 23.3913 23.5865 23.0865C23.8913 22.7818 24.0625 22.3685 24.0625 21.9375V4.0625ZM22.4375 4.0625V7.3125H4.5625V4.0625H22.4375ZM22.4375 21.9375H4.5625V18.6875H22.4375V21.9375ZM22.4375 17.0625H4.5625V13.8125H22.4375V17.0625ZM22.4375 12.1875H4.5625V8.9375H22.4375V12.1875Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
